module.exports = __webpack_public_path__ + "img/pickUpRestaurant.67609acd.svg";